// extracted by mini-css-extract-plugin
module.exports = {"fullFaq":"FullFAQ_fullFaq__PcgGJ","headContainer":"FullFAQ_headContainer__CyeZm","faqContainer":"FullFAQ_faqContainer__jdyXT"};